//Image has postion absolute, todo: find better way to style img with relative position
export const styles = {
  container: "w-full h-full",
  image: "!relative object-cover",
};

export type HyamPrismicImageStyles =
  typeof styles;
